import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import { SearchAgendaComprasOsModel } from '../../../models/reserva-compras.model'

@Injectable({
  providedIn: 'root',
})
export class AgendaComprasService {
  private baseUrl = environment.baseUrl
  private resource = 'AgendaCompras'

  constructor(private httpClient: HttpClient) {}

  public listPagedOs(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedOs(
    page: number,
    rows = 15,
    model: SearchAgendaComprasOsModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
